import React from "react";
import { Link } from "react-router-dom";

export default function RedeemSuccess({
  creditsRedeemed,
  hash,
  redeemType,
  tokenIds,
  partialHash,
}) {
  return (
    <div className="thank-you text-center">
      <svg
        width="24"
        height="17"
        viewBox="0 0 24 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.96777 10.4862L7.18718 14.6617C8.41167 15.6413 10.1876 15.4961 11.2367 14.3305L22.689 1.60571"
          stroke="url(#paint0_linear_290_688)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_290_688"
            x1="12.3284"
            y1="1.60571"
            x2="12.3284"
            y2="15.3105"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#75FBFD" />
            <stop offset="1" stopColor="#75FBFD" stopOpacity="0.44" />
          </linearGradient>
        </defs>
      </svg>
      <small className="font-mono text-uppercase d-block my-4">
        YOU SUCCESSFULLY REDEEMED{" "}
        <span className="text-blue">{creditsRedeemed}</span> BRAIN CREDITS.{" "}
        <br />
        {redeemType === "partial" ? (
          <>
            <br />
            <span>
              YOUR CREDITS HAVE ENTERED THE COLLECTIVE MINTING POOL. ONCE 1000
              CREDITS HAVE BEEN CONTRIBUTED TO THIS POOL A BRAIN WILL BE MINTED
              AND YOU WILL RECEIVE BRAIN TOKENS COMMENSURATE WITH YOUR SHARE OF
              THE POOL.
            </span>
          </>
        ) : (
          tokenIds.length > 0 && (
            <span>
              You received {tokenIds.length} Brain(s).
              <br />
              <br />
              {tokenIds.map((id) => (
                <Link
                  style={{ textDecoration: "none", color: "#e2e2e2" }}
                  to={`/configure-metadata`}
                  key={id}
                >
                  Brain #{id} - Set Metadata {">"}
                </Link>
              ))}
            </span>
          )
        )}
        <br />
        <br />
        <Link
          style={{ color: "#e2e2e2" }}
          to={`https://etherscan.io/tx/${
            redeemType === "partial" ? partialHash : hash
          }`}
        >
          VIEW ON ETHERSCAN
        </Link>
      </small>
      <div>
        <Link
          to="/my-inventory"
          className="button align-items-center d-flex justify-content-center"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12.3574" cy="12.0234" r="12" fill="black" />
            <path
              d="M12.3574 8.78125L14.9508 12.023L12.3574 15.2647"
              stroke="#75FBFD"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="ps-3">Go to My Inventory</span>
        </Link>
      </div>
    </div>
  );
}
